import { atom } from 'jotai';
import { API } from "../../../../common/constants";
import { UploadFile } from 'antd';
import { atomWithHash } from 'jotai-location';

// Import from ddex_atoms
export { warningsAtom, isReleaseInfoLoadingAtom } from '../ddex_atoms';

// Define types for batch processing
export interface UploadedFile {
    name: string;
    url: string;
    size?: number;
    type?: string;
    lastModified?: number;
}

export interface ConfirmationModalState {
    visible: boolean;
    upcCount: number;
    isrcCount: number;
    previewUPC: string;
    previewISRCs: Record<string, string>;
    validationWarnings: API.MusicDistribution.ValidationError[];
}

// Define atoms for batch processing
export const batchAtom = atom<Partial<API.MusicDistribution.ReleaseBatch>>({});
export const batchItemsAtom = atom<API.MusicDistribution.ReleaseBatchItem[]>([]);
export type BatchUploadStep = 'upload-excel' | 'upload-files' | 'verify';
export const currentStepAtom = atomWithHash('currentStep', 'upload-excel' as BatchUploadStep);
export const uploadedFilesAtom = atom<Record<string, any[]>>({});
export const previewDataAtom = atom<Record<string, any>>({});
export const confirmationModalAtom = atom<ConfirmationModalState>({
    visible: false,
    upcCount: 0,
    isrcCount: 0,
    previewUPC: '',
    previewISRCs: {},
    validationWarnings: []
});
